import byteSize from 'byte-size'
import React from 'react'

type DAFileSizeSpan = {
  fileSize?: number
}

const DAFileSizeSpan: React.FC<DAFileSizeSpan> = ({ fileSize }) => {
  if (fileSize) {
    const size = byteSize(fileSize)
    return (
      <>
        {size.value} {size.unit}
      </>
    )
  }
  return <>--</>
}

export default DAFileSizeSpan
